import { render, staticRenderFns } from "./mafter.vue?vue&type=template&id=ba6750a2&scoped=true&"
import script from "./mafter.vue?vue&type=script&lang=js&"
export * from "./mafter.vue?vue&type=script&lang=js&"
import style0 from "./mafter.vue?vue&type=style&index=0&id=ba6750a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6750a2",
  null
  
)

export default component.exports